import styled from 'styled-components/macro';
import { Dropdown as AntDropdown } from 'antd';

export const Dropdown = styled(AntDropdown)``;
